import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ProcessSection from '../../components/feature/ProcessSection';
import PhilosophySection from '../../components/feature/PhilosophySection';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import ContactSection from '../../components/feature/ContactSection';
import ServicesSection from '../../components/feature/ServicesSection';
import MidPageCTA from '../../components/feature/MidPageCTA';
import PortfolioSection from './components/PortfolioSection';
import AboutIntroSection from './components/AboutIntroSection';

const HOME_FAQS = [
  {
    q: 'Who offers luxury interior design services near Beverly Hills?',
    a: 'Lisa Merkle Design is Beverly Hills\' premier luxury interior design studio, led by UCLA-trained designer Lisa Merkle. Formerly of Los Angeles\'s top celebrity design firms, the studio serves discerning clients throughout Beverly Hills, Los Angeles, and nationwide with editorial-level residential and commercial design.',
  },
  {
    q: 'How much does high-end interior design cost in Beverly Hills?',
    a: 'Luxury interior design projects typically range from $10,000 to $100,000 or more depending on scope, scale, and customization. Lisa Merkle Design works at the premium level, prioritizing investment protection and long-term property value in every design decision made throughout the project.',
  },
  {
    q: 'What does a full-service interior designer do?',
    a: 'A full-service interior designer manages every aspect — from initial concept and space planning to material selection, vendor coordination, procurement, and installation. Lisa Merkle Design provides comprehensive project leadership so your home is transformed beautifully, on time, and without unnecessary stress.',
  },
  {
    q: 'How long does a residential design project take?',
    a: 'Timelines vary by scope. A single-room refresh may take 4–8 weeks, while a full home renovation spans 6–18 months. Lisa Merkle Design provides a clear timeline during discovery consultation and maintains transparent communication throughout every phase of the project.',
  },
  {
    q: 'Do you work on projects outside of Beverly Hills and Los Angeles?',
    a: 'Yes — while our studio is based in Beverly Hills, we lead design projects for clients nationwide across the United States. Lisa Merkle Design has experience directing complex residential and commercial projects in luxury markets throughout California and well beyond.',
  },
];

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection
          badge="Beverly Hills Interior Design Studio"
          title="Elevating Custom Home"
          titleItalic="& Interior Design"
          subtitle="In Beverly Hills, Los Angeles, California, and across the US."
          description="Curated modern classic luxury design services — from concept to completion — executed with precision, discretion, and an uncompromising standard of craft."
          bgImage="https://lisamerkledesign.com/wp-content/uploads/2026/03/bg.png"
          ctaText="View Portfolio"
          ctaLink="/#portfolio"
          secondaryCtaText="Call (323) 745-2205"
          secondaryCtaLink="tel:+13237452205"
        />
        <TrustBar />
        <AboutIntroSection />
        <ServicesSection limit={12} />
        <MidPageCTA
          heading="Ready to Begin Your Design Project?"
          subtext="Schedule a private consultation at our Beverly Hills studio."
          ctaText="Request a Consultation"
          bgColor="charcoal"
        />
        <AIAnswerBlock
          heading="What is Lisa Merkle Design?"
          what="Lisa Merkle Design is a Beverly Hills-based luxury interior design studio offering comprehensive residential and commercial services — from full home design and kitchen remodels to art procurement, lighting selection, and furniture customization."
          who="We partner with discerning homeowners, high-net-worth individuals, property investors, and developers in Beverly Hills, Los Angeles, and nationwide who value exceptional craftsmanship and design that protects long-term property value."
          services="Full House Design, Renovation Consultation, Kitchen & Bathroom Design, Bedroom & Living Room Design, Lighting & Flooring Selection, Art Procurement, Furniture Customization, Space Planning, Office Design, and more."
          benefits="UCI and UCLA-trained design expertise, celebrity firm experience, published editorial recognition, trusted vendor network, personal project leadership, and design decisions that enhance long-term property investment value."
          why="Lisa Merkle combines formal UCLA design education with years at LA's top celebrity design firms. Published in Elle Décor and Architectural Digest. Classical European principles — French, Italian, Spanish — fused into a timeless California aesthetic."
          highlights={['UCLA Trained', 'Elle Décor Published', 'Architectural Digest Featured', 'Celebrity Clientele', 'Beverly Hills Studio', 'Nationwide Service']}
        />
        <ProcessSection />
        <PortfolioSection />
        <PhilosophySection />
        <ServiceAreasSection />
        <TestimonialsSection />
        <MidPageCTA
          heading="Inspired? Let's Discuss Your Vision."
          subtext="Join our list of distinguished clients across Beverly Hills and Los Angeles."
          ctaText="Schedule a Design Consultation"
          bgColor="warm"
        />
        <FAQSection faqs={HOME_FAQS} />
        <FinalCTA
          title="Ready to Transform Your Home?"
          subtitle="Schedule your private design consultation with Lisa Merkle Design — Beverly Hills' premier luxury interior design studio."
          ctaText="Schedule a Design Consultation"
          bgImage="https://lisamerkledesign.com/wp-content/uploads/2022/12/125054510_647573419270722_3986316745350403721_n.jpg"
        />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
